import { useMemo } from "react";
import { queries } from "../../shared/queries";
import { useQuery } from "./useQuery";

export function useCurrentUserGrants() {
  const [direct] = useQuery(queries.currentUserDirectGrants());
  const [groups] = useQuery(queries.currentUserGroupGrants());
  return useMemo(
    () => [
      ...(direct ?? []),
      ...(groups ?? []).flatMap((g) => g.roleGrantsAsPrincipal),
    ],
    [direct, groups]
  );
}
